var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFintech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#37C07E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.429 2341c-6.299 0-11.429 5.13-11.429 11.429v.002c.005 3.61 1.758 6.909 4.571 9.04v2.386h13.715v-2.377c2.815-2.133 4.57-5.438 4.571-9.051 0-6.299-5.13-11.429-11.428-11.429zm-1.143 4.571h2.285v1.143c1.88 0 3.429 1.549 3.429 3.429h-2.286c0-.645-.498-1.143-1.143-1.143h-2.285c-.645 0-1.143.498-1.143 1.143s.498 1.143 1.143 1.143h2.285c1.88 0 3.429 1.548 3.429 3.428s-1.549 3.429-3.429 3.429v1.143h-2.285v-1.143c-1.88 0-3.429-1.549-3.429-3.429h2.286c0 .645.498 1.143 1.143 1.143h2.285c.645 0 1.143-.498 1.143-1.143 0-.644-.498-1.143-1.143-1.143h-2.285c-1.88 0-3.429-1.548-3.429-3.428s1.549-3.429 3.429-3.429v-1.143zm-5.715 20.572v2.286h13.715v-2.286H538.57zm2.286 4.571V2373H550v-2.286h-9.143z",
    transform: "translate(-534 -2341)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFintech);
export default __webpack_public_path__ + "static/media/icon-fintech.25e6183fb271f4eeb62db5078bed8847.svg";
export { ForwardRef as ReactComponent };